import { Service, SWRConfiguration, useGet, useList, useRead } from "@api/common";
import { Invoice, ListParams, Org, ReadParams } from "./types";

export type { Invoice, Org };

export class OrgService extends Service<Org> {
  constructor() {
    super("/orgs");
  }

  async createOrg(body: Partial<Org>): Promise<{ org: Org }> {
    return this.post(`${this.basePath}`, body);
  }

  async transferOwnership(orgId: string, toUser: string) {
    return this.put(`${this.basePath}/${orgId}/transfer-ownership`, { user: toUser });
  }

  async removePaymentMethod(orgId: string, paymentMethodId: string) {
    return this.delete(`${this.basePath}/${orgId}/payment-methods/${paymentMethodId}`);
  }
}

export const orgService = new OrgService();

export function useOrgs(params?: ListParams<Org>, config?: SWRConfiguration) {
  return useList(orgService, params, config);
}

export function useOrg(id: string | undefined, params?: ReadParams, config?: SWRConfiguration) {
  return useRead(orgService, id, { populate: "owner", ...params }, config);
}

export function useOrgInvoices(id: string, config?: SWRConfiguration) {
  return useGet<Invoice[]>(orgService, `${orgService.basePath}/${id}/invoices`, {}, config);
}
